import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Breadcrumb from './components/Breadcrumb';
import SiteUpgrade from './components/SiteUpgrade';
import ContactPage from './components/ContactPage';
import ServicesPage from './components/ServicesPage';
import ServiceDetailPage from './components/ServiceDetailPage';
import GalleryPage from './components/GalleryPage';
import HomePage from './components/HomePage';
import StairsPage from './components/StairsPage';
import WindowsPage from './components/WindowsPage';
import DoorsPage from './components/DoorsPage';
import GatesPage from './components/GatesPage';
import MiscellaneousPage from './components/MiscellaneousPage';
import MouldingsPage from './components/MouldingsPage';
import WorkshopPage from './components/WorkshopPage';
import AboutPage from './components/AboutPage';
import OurWorkPage from './components/OurWorkPage';
import AccoyaPage from './components/AccoyaPage';
import MaterialsCraftsmanshipPage from './components/MaterialsCraftsmanshipPage';


function App() {
  const location = useLocation();

  // ✅ NEW: store current service title for breadcrumb
  const [serviceTitle, setServiceTitle] = useState(null);

  useEffect(() => {
    if (!location.pathname.startsWith('/services/')) {
      setServiceTitle(null);
    }
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const getBreadcrumbItems = () => {
    const path = location.pathname;

    // Home only
    if (path === '/') {
      return [{ label: 'Home' }];
    }

    // Services index
    if (path === '/services') {
      return [
        { label: 'Home', link: '/' },
        { label: 'Our Services' },
      ];
    }

    // Service detail (dynamic)
    if (path.startsWith('/services/')) {
      return [
        { label: 'Home', link: '/' },
        { label: 'Our Services', link: '/services' },
        { label: serviceTitle || 'Loading…' }, // ✅ now dynamic
      ];
    }

    // Contact
    if (path === '/contact') {
      return [
        { label: 'Home', link: '/' },
        { label: 'Contact' },
      ];
    }

    // Gallery
    if (path === '/gallery') {
      return [
        { label: 'Home', link: '/' },
        { label: 'Gallery' },
      ];
    }

    return [];
  };

  

  return (
    <div className="page">
      <Header />

      {/* Breadcrumb kept for future use, currently hidden */}
      {false && <Breadcrumb items={getBreadcrumbItems()} />}

      <main className="content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/site-upgrade" element={<SiteUpgrade />} />
          <Route path="/services" element={<ServicesPage />} />

          {/* ✅ PASS setter into detail page */}
          <Route
            path="/services/:slug"
            element={<ServiceDetailPage setBreadcrumbLabel={setServiceTitle} />}
          />

          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/our-work" element={<OurWorkPage />} />
          <Route path="/our-work/stairs" element={<StairsPage />} />
          <Route path="/our-work/windows" element={<WindowsPage />} />
          <Route path="/our-work/doors" element={<DoorsPage />} />
          <Route path="/our-work/gates" element={<GatesPage />} />
          <Route path="/our-work/mouldings" element={<MouldingsPage />} />
          <Route path="/our-work/miscellaneous" element={<MiscellaneousPage />} />
          <Route path="/workshop" element={<WorkshopPage />} />
          <Route path="/accoya" element={<AccoyaPage />} />
          <Route path="/materials-craftsmanship" element={<MaterialsCraftsmanshipPage />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default App;
